import React, { useState, useEffect } from 'react';
import { useAttendance } from '../context/AttendanceContext';
import { useSelector } from 'react-redux';
import configServ from '../services/config';
import './Leave.css';
import configService from '../services/config';
import toast from 'react-hot-toast';
import LeaveTable from './LeaveTable';

const STATUS_COLORS = {
  Pending: { bg: 'rgba(245,166,35,0.1)', color: '#f5a623', border: 'rgba(245,166,35,0.25)' },
  Approved: { bg: 'rgba(34,211,165,0.1)', color: '#22d3a5', border: 'rgba(34,211,165,0.25)' },
  Rejected: { bg: 'rgba(242,95,92,0.1)', color: '#f25f5c', border: 'rgba(242,95,92,0.25)' },
};

export default function Leave() {
  const { leaves, applyLeave } = useAttendance();
  const { company_id, userId } = useSelector(state => state.globalVariables);

  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    leave_type_id: '',
    from_date: '',
    to_date: '',
    reason: '',
    leave_list_id: ''
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [isChanged, setIsChanged] = useState(false);

  const today = new Date().toISOString().split('T')[0];

  const selectedLeaveObj = leaveTypes.find(t => Number(t.id) === Number(form.leave_type_id));
  const isRH = selectedLeaveObj?.leave_code === "RH";

  const fetchLeaveData = async () => {
    try {
      const [typesRes, holidaysRes] = await Promise.all([
        configServ.getleaveTypes(),
        configServ.getActiveGlobalHolidays(company_id)
      ]);
      if (typesRes?.status) setLeaveTypes(typesRes.data);
      if (holidaysRes?.status) setLeaveList(holidaysRes.data);
    } catch (error) {
      console.error("Error fetching leave data:", error);
    }
  };

  useEffect(() => {
    if (showForm) {
      fetchLeaveData();
    }
  }, [showForm]);

  const handleTypeChange = (e) => {
    const val = e.target.value;
    setForm({ ...form, leave_type_id: val, from_date: '', to_date: '', leave_list_id: '' });
    setErrors({});
  };

  const handleHolidayChange = (e) => {
    const holidayId = e.target.value;
    const selectedHoliday = leaveList.find(h => h.id == holidayId);
    const hDate = selectedHoliday?.holiday_date ? selectedHoliday.holiday_date.split('T')[0] : '';

    setForm({
      ...form,
      leave_list_id: holidayId,
      from_date: hDate,
      to_date: hDate
    });
  };

  const validate = () => {
    const e = {};
    if (!form.leave_type_id) e.leave_type_id = 'Leave type is required';

    if (isRH) {
      if (!form.leave_list_id) e.leave_list_id = 'Please select a holiday';
    } else {
      if (!form.from_date) e.from_date = 'Start date is required';
      if (!form.to_date) e.to_date = 'End date is required';
      else if (form.to_date < form.from_date) e.to_date = 'End date must be after start date';
    }

    if (!form.reason.trim()) e.reason = 'Reason is required';
    else if (form.reason.trim().length < 10) e.reason = 'Min 10 characters required';

    return e;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }

    const payload = {
      company_id,
      employee_id: userId,
      ...form
    };

    try {
      const response = await configServ.createLeave(payload);

      if (response?.status) {
        toast.success("Leave application submitted successfully");

        // Agar context update karna hai toh response data ke saath call karein
        // applyLeave(response.data || payload);
        setSubmitted(true);
        setIsChanged(prev => !prev); // Trigger re-fetch in LeaveTable

        setTimeout(() => {
          setSubmitted(false);
          setShowForm(false);
          setForm({ leave_type_id: '', from_date: '', to_date: '', reason: '', leave_list_id: '' });
          setErrors({});
        }, 1800);
      } else {
        toast.error(response?.message || "Failed to submit leave");
      }
    } catch (error) {
      console.error("Submit Error:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const days = (from, to) => {
    if (!from || !to) return 0;
    const d = (new Date(to) - new Date(from)) / 86400000 + 1;
    return d > 0 ? Math.ceil(d) : 0;
  };

  const fmt = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

  return (
    <div className="leave-root fade-in-up" style={{width: '100%'}}>
      <div className="leave-header-row">
        <div>
          <h2 className="leave-title">Leave Requests</h2>
          {/* <p className="leave-subtitle">{leaves.length} total · {leaves.filter(l => l.status === 'Pending').length} pending</p> */}
        </div>
        <button className="leave-apply-btn" onClick={() => setShowForm(v => !v)}>
          {showForm ? 'Cancel' : 'Apply for Leave'}
        </button>
      </div>

      {showForm && (
        <div
          className="leave-form-card page-card fade-in-up"
          style={{
            backgroundColor: '#ffffff',
            color: '#1e293b',
            padding: '24px',
            borderRadius: '16px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 10px 25px rgba(0,0,0,0.05)'
          }}
        >
          <p className="page-section-title" style={{ color: '#1e293b', fontWeight: 700, marginBottom: '16px', fontSize: '1.1rem' }}>
            New Leave Application
          </p>
          <form onSubmit={handleSubmit} className="leave-form" noValidate>
            <div className="leave-form-grid">
              <div className={`leave-field ${errors.leave_type_id ? 'has-error' : ''}`}>
                <label className="leave-label">Leave Type</label>
                <select className="leave-select" value={form.leave_type_id} onChange={handleTypeChange}>
                  <option value="">Select Type</option>
                  {leaveTypes.map(t => (
                    <option key={t.id} value={t.id}>{t.leave_name}</option>
                  ))}
                </select>
                {errors.leave_type_id && <span className="leave-err">{errors.leave_type_id}</span>}
              </div>

              {isRH ? (
                <div className={`leave-field ${errors.leave_list_id ? 'has-error' : ''}`}>
                  <label className="leave-label">Select Holiday</label>
                  <select className="leave-select" value={form.leave_list_id} onChange={handleHolidayChange}>
                    <option value="">Choose Restricted Holiday</option>
                    {leaveList.map(h => (
                      <option key={h.id} value={h.id}>{h.title} ({fmt(h.holiday_date)})</option>
                    ))}
                  </select>
                  {errors.leave_list_id && <span className="leave-err">{errors.leave_list_id}</span>}
                </div>
              ) : (
                <div className={`leave-field ${errors.from_date ? 'has-error' : ''}`}>
                  <label className="leave-label">From Date</label>
                  <input
                    type="date"
                    className="leave-input"
                    min={today}
                    value={form.from_date}
                    onChange={e => setForm(f => ({ ...f, from_date: e.target.value }))}
                  />
                  {errors.from_date && <span className="leave-err">{errors.from_date}</span>}
                </div>
              )}

              <div className={`leave-field ${errors.to_date ? 'has-error' : ''}`}>
                <label className="leave-label">To Date</label>
                <input
                  type="date"
                  className="leave-input"
                  min={form.from_date || today}
                  disabled={isRH}
                  value={form.to_date}
                  onChange={e => setForm(f => ({ ...f, to_date: e.target.value }))}
                />
                {errors.to_date && <span className="leave-err">{errors.to_date}</span>}
              </div>
            </div>

            {form.from_date && form.to_date && (
              <div className="leave-days-pill">
                {days(form.from_date, form.to_date)} day{days(form.from_date, form.to_date) > 1 ? 's' : ''} selected
              </div>
            )}

            <div className={`leave-field ${errors.reason ? 'has-error' : ''}`}>
              <label className="leave-label">Reason</label>
              <textarea
                className="leave-textarea"
                rows={3}
                placeholder="Describe the reason for your leave..."
                value={form.reason}
                onChange={e => setForm(f => ({ ...f, reason: e.target.value }))}
              />
              {errors.reason && <span className="leave-err">{errors.reason}</span>}
            </div>

            <div className="leave-form-actions">
              <button type="submit" className={`leave-submit-btn ${submitted ? 'done' : ''}`} disabled={submitted}>
                {submitted ? 'Submitted!' : 'Submit Application'}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* <div className="leave-list page-card delay-1 fade-in-up" style={{ backgroundColor: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px' }}>
        {leaves.length === 0 ? (
          <div className="leave-empty">
            <p style={{ color: '#334155' }}>No leave applications yet</p>
          </div>
        ) : (
          <div className="leave-items">
            {leaves.map((l) => {
              const sc = STATUS_COLORS[l.status] || STATUS_COLORS.Pending;
              return (
                <div key={l.id} className="leave-item">
                  <div className="leave-item-left">
                    <div className="leave-type-badge">{l.type}</div>
                    <p className="leave-item-reason">{l.reason}</p>
                    <div className="leave-item-meta">
                      <span>{fmt(l.from_date)} → {fmt(l.to_date)}</span>
                      <span className="leave-dot">·</span>
                      <span>{days(l.from_date, l.to_date)} days</span>
                    </div>
                  </div>
                  <span className="leave-status-badge" style={{ background: sc.bg, color: sc.color, border: `1px solid ${sc.border}` }}>
                    {l.status}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div> */}

      <LeaveTable ischange={isChanged} />
    </div>
  );
}